module.exports = __webpack_public_path__ + "static/media/our-locations.8f65e3fb.jpg";